// extracted by mini-css-extract-plugin
module.exports = {"default":"ColorDotList_default__2AlkP","amount":"ColorDotList_amount__-N3o7"};